<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 min-h-screen flex flex-col pb-5">
            <TopBar title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25 flex flex-col flex-1">
                <div class="bg-white rounded-25 p-10 mx-3 h-full flex-1">
                    <div class="text-24 text-tc-blue-2 text-center">{{lbl.otp.headline}}</div>
                    <div class="my-3 text-20 text-tc-gray-3 text-center">{{lbl.otp.contact_number_lbl}}</div>
                    <div class="mb-3 text-34 text-tc-blue-2 text-center">{{displayContantNumber}}</div>
                    <div class="mb-4 text-20 text-tc-gray-3 text-center">{{lbl.otp.refcode_lbl}}{{refcode}}</div>
                    <OtpInput
                        class="mb-5"
                        ref="otp_input"
                        v-model:inputValid="isOtpValid"
                        v-model:inputOtp="otp" />
                    <div class="mb-4 font-main-medium text-20 text-tc-orange-1 text-center"
                        v-if="isError" v-html="errorMsg">
                    </div>
                    <div class="text-center">
                        <div
                            class="mb-4 text-tc-gray-1 text-20 mx-auto">
                            {{lbl.otp.timeleft}} <span class="text-tc-orange-1">{{timeLeft}}</span>
                        </div>
                        <div v-if="isOtpExpire" @click="resendOtp()"
                            class="mb-4 ml-auto mr-2 font-main-medium text-20 text-1c3e95 text-center underline">
                            {{lbl.otp.resend_otp}}
                        </div>
                    </div>
                    <div class="grid gap-3">
                        <div class="w-250px text-20 mx-auto">
                            <BlueBtn @click="clickVerifyOtp()" :isBtnDisabled="!isValid">{{lbl.otp.confirm}}</BlueBtn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
    </div>
</template>
<script>

// helper
import Util from '@/helper/Utility.js';
import TimerHelper from "@/helper/TimerHelper.js";
import ForgetPasswordOtpService from '../Service/ForgetPasswordOtpService'
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import OtpInput from "@/components/Authen/Otp/OtpInput.vue";
import BlueBtn from "@/components/Button/BlueBtn.vue"
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';

// import CountDownTimer from '@/components/Utility/CountDownTimer.vue';
// mixin
import LocaleMixin from "@/mixin/LocaleMixin";
//service

export default {
    name: 'verifyotp',
    mixins: [LocaleMixin],
    props:{
        otpData: Object,
        modalController: Object
    },
    components: {
        TopBar,
        MenuDesktop,
        OtpInput,
        BlueBtn,
        BottomBar
        // CountDownTimer,
    },
    data: function () {
        return {
            isOtpExpire: false,
            refcode: '',
            tel: '',

            timeHelper: new TimerHelper(),
            timeLeft: '',
            expireIn: 0,
            isError: false,
            isOtpValid: false,
            otp: '',
            errorMsg: ''
        }
    },
    created:async function(){
        this.tel = this.otpData.tel;
        this.refcode = this.otpData.refcode;
    },
    computed: {
        displayContantNumber: function () {
            if(this.tel){
                return Util.contactNumberFormat(this.tel, '-');
            }
            return ''
        },
        isValid: function () {
            return this.isOtpValid && !this.isOtpExpire;
        }
    },
    mounted: function () {
        if(this.tel && this.refcode){
            this.initialOtp();
        }
    },
    methods: {
        initialOtp: async function () {
            this.timeHelper.initialTimer(this.expireIn, ':', false, false);
            this.timeHelper.runTimer((timeLeft) => {
                this.timeLeft = timeLeft;
            }, () => {
                this.setTimeout();
            });
        },
        //#region resend otp
        resendOtp: function() {
            this.isOtpExpire = false;
            this.refcode = '';
            this.otp = '';
            this.isError = false;
            this.errorMsg = '';

            this.$refs['otp_input'].resetOtp();

            this.onResendOtp();

        },
        onResendOtp: async function () {
            this.modalController.loadingModal.show();

            await this.callApiOtp();

            this.modalController.loadingModal.hide();
            this.timeHelper.runTimer((timeLeft) => {
                this.timeLeft = timeLeft;
            }, () => {
                this.setTimeout();
            });
        },
        //#endregion resend otp
        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isOtpExpire = true;
        },
        clickVerifyOtp: async function () {
            if (!this.isValid) {
                return
            }
            this.modalController.loadingModal.show();
            var success = await this.apiValidateOtp();
            this.modalController.loadingModal.hide();
            if(success){
                this.$emit('submitOtp', {tel: this.tel , refcode: this.refcode , otp: this.otp});
            }
        },
        apiValidateOtp: function(){
            return new Promise((resolve) => {
                ForgetPasswordOtpService.validateOtp(this.tel , this.refcode , this.otp)
                .subscribe({
                    next: (res) => {
                        console.log(res)
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err)
                        this.handleError(err);
                        resolve(false);
                    }
                });
            })
        },
        handleError: function (err) {
            if (err.id == 2091 && err.code == 409) {
                this.isError = true
                this.errorMsg = this.lbl.otp.otp_incorrect + '<br>' + 'Error Code ' + this.refcode;
            }else{
                this.modalController.alertModal.setTitle(this.lbl.profile.error).setMsg(err.message).show();
            }
        },
    }

}
</script>
